import { formatNumberWithCommas } from "Utilities/Number/formatNumberWithCommas";

export function formatAmountInCentsForDisplay(amount, keepTrailingZeros) {
  const inDollars = (amount / 100).toFixed(2);
  const withCommas = formatNumberWithCommas(inDollars);
  const result = keepTrailingZeros
    ? withCommas
    : String(withCommas).replace(".00", "");
  return result;
}
